import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Sidenav from '../../vendor/libs/sidenav';
import layoutHelpers from './helpers';

class LayoutSidenav extends Component {
  layoutSidenavClasses() {
    let bg = this.props.sidenavBg;

    if (
      this.props.orientation === 'horizontal' &&
      (bg.indexOf(' sidenav-dark') !== -1 ||
        bg.indexOf(' sidenav-light') !== -1)
    ) {
      bg = bg
        .replace(' sidenav-dark', '')
        .replace(' sidenav-light', '')
        .replace('-darker', '')
        .replace('-dark', '');
    }

    return (
      `bg-${bg} ` +
      (this.props.orientation !== 'horizontal'
        ? 'layout-sidenav'
        : 'layout-sidenav-horizontal container-p-x flex-grow-0')
    );
  }

  toggleSidenav(e) {
    e.preventDefault();
    layoutHelpers.toggleCollapsed();
  }

  isMenuActive(url) {
    return this.props.location.pathname.indexOf(url) === 0;
  }

  isMenuOpen(url) {
    return (
      this.props.location.pathname.indexOf(url) === 0 &&
      this.props.orientation !== 'horizontal'
    );
  }

  render() {
    const { t } = this.props;
    return (
      <Sidenav
        orientation={this.props.orientation}
        className={this.layoutSidenavClasses()}
      >
        {/* Inner */}
        <div
          className={`sidenav-inner ${
            this.props.orientation !== 'horizontal' ? 'py-1' : ''
          }`}
        >
          <Sidenav.RouterLink
            to="/surveys"
            exact={true}
            icon="ion ion-ios-albums"
          >
            {t('layouts.my surveys')}
          </Sidenav.RouterLink>
          <Sidenav.RouterLink
            to="/surveys/new"
            exact={true}
            icon="ion ion-md-add-circle"
          >
            {t('layouts.new survey')}
          </Sidenav.RouterLink>
          {/* <Sidenav.RouterLink
            to="/app/feedback"
            target="_blank"
            exact={true}
            icon="ion ion-md-happy"
          >
            {t('layouts.suggest feature')}
          </Sidenav.RouterLink> */}
          <Sidenav.RouterLink
            to="/settings"
            exact={true}
            icon="ion ion-md-settings"
            className="text-right"
          >
            {t('layouts.account settings')}
          </Sidenav.RouterLink>
        </div>
      </Sidenav>
    );
  }
}

LayoutSidenav.propTypes = {
  orientation: PropTypes.oneOf(['vertical', 'horizontal'])
};

LayoutSidenav.defaultProps = {
  orientation: 'vertical'
};

export default connect(store => ({
  sidenavBg: store.theme.sidenavBg
}))(withTranslation()(LayoutSidenav));
